import { Route, Routes } from "react-router-dom";
import BrowserRules from "../../Browser/BrowserRules/BrowserRules";
import MatchBetBreakdownPage from "../../common/pages/MatchBetBreakdownPage";
import { ProtectedRoute } from "../../common/routing/ProtectedRoute";
import { PublicOnlyRoute } from "../../common/routing/PublicOnlyRoute";
import { MobileBets } from "../MobileBets/MobileBets";
import CreateLeaguePanel from "../MobileCreationWizard/CreateLeaguePanel";
import { MobileWizard } from "../MobileCreationWizard/MobileWizard";
import { MobileFAQ } from "../MobileFAQ";
import { MobileFixtures } from "../MobileFixtures/MobileFixtures";
import { MobileLeagues } from "../MobileLeagues/MobileLeagues";
import { MobileProfile } from "../MobileProfile/MobileProfile";
import { MobileRanking } from "../MobileRanking/MobileRanking";
import { MobileSignIn } from "../MobileSign/MobileSignIn";

interface MobileBodyProps {}

export const MobileBody: React.FC<MobileBodyProps> = () => {
  return (
    <Routes>
      {/* in future give direction to homepage */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MobileProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/login"
        element={
          <PublicOnlyRoute>
            <MobileSignIn />
          </PublicOnlyRoute>
        }
      />
      <Route
        path="/bets"
        element={
          <ProtectedRoute>
            <MobileBets />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createAccount"
        element={
          <PublicOnlyRoute>
            <MobileWizard />
          </PublicOnlyRoute>
        }
      />
      <Route
        path="/fixtures"
        element={
          <ProtectedRoute>
            <MobileFixtures />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ranking"
        element={
          <ProtectedRoute>
            <MobileRanking />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <MobileProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leagues"
        element={
          <ProtectedRoute>
            <MobileLeagues isUserSigned />
          </ProtectedRoute>
        }
      />
      <Route path="/faq" element={<MobileFAQ />} />
      <Route
        path="/rules"
        element={
          <ProtectedRoute>
            <BrowserRules />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createLeague"
        element={
          <ProtectedRoute>
            <CreateLeaguePanel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/match/:matchId/bets-breakdown"
        element={
          <ProtectedRoute>
            <MatchBetBreakdownPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export type RoutePath =
  | "/"
  | "/bets"
  | "/fixtures"
  | "/ranking"
  | "/profile"
  | "/leagues"
  | "/faq"
  | "/rules";
